import { Form, FormInstance } from "antd";
import { useGetSettingsQuery } from "../../../api/queries";
import FormItemInputNumber from "../../../components/ui/FormItemInputNumber/FormItemInputNumber";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { useEffect, useRef } from "react";
import { ISettings } from "../../../models/Settings";
import { useSettingsMutations } from "../../../api/mutations";
import { openSuccessMessage } from "../../../store/message/messageSlice";
import { handleError } from "../../../helper/errorHandler";
import useAppDispatch from "../../../hooks/useAppDispatch";

const GeneralSettings = () => {
  const dispatch = useAppDispatch();
  const formRef = useRef<FormInstance>(null);
  const { t } = useTranslation();
  const { data: settings } = useGetSettingsQuery();
  const { editSettings } = useSettingsMutations();

  useEffect(() => {
    if (settings && formRef.current) {
      formRef.current.setFieldsValue({
        refundCancellationHours: settings.refundCancellationHours,
        classVisibilityWeeks: settings.classVisibilityWeeks,
        classReminderHours: settings.classReminderHours,
        subscriptionTrialPeriodDays: settings.subscriptionTrialPeriodDays,
      });
    }
  }, [settings, formRef]);

  const onFinish = (values: Omit<ISettings, "id">) => {
    editSettings(values, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("SettingsChangedSuccessfully")));
      },
      onError: (e) => handleError(e, dispatch, t),
    });
  };

  return (
    <Form
      ref={formRef}
      className={"form"}
      name="general-settings"
      onFinish={onFinish}
      autoComplete="off"
      layout={"vertical"}
      style={{ width: "500px" }}
    >
      <FormItemInputNumber
        name={"refundCancellationHours"}
        label={t("HowManyHoursBeforeClassCancellationQualifiesForARefund")}
        rules={{ required: true }}
      />
      <FormItemInputNumber
        name={"classVisibilityWeeks"}
        label={t("HowManyWeeksAheadToDisplayClasses")}
        rules={{ required: true }}
      />
      <FormItemInputNumber
        name={"classReminderHours"}
        label={t("HowManyHoursBeforeYouWantClients")}
        rules={{ required: true }}
      />
      <FormItemInputNumber
        name={"subscriptionTrialPeriodDays"}
        label={t("SubscriptionTrialPeriodDays")}
        rules={{ required: true }}
      />

      <br />
      <CustomButton text={t("SaveChanges")} type={"submit"} typeStyle={"fill"} />
    </Form>
  );
};

export default GeneralSettings;
